<template>
    <div>
        <div
            class="comm-settings-top-nav d-inline-flex w-100"
            :class="{
                'metadata-top-nav': metadataView || (!metadataView && (getIsMetadataDockVisible || getIsAssetsDetailsPanelVisible)),
                'normal-panel-top-nav': !metadataView && (getIsMetadataDockVisible || getIsAssetsDetailsPanelVisible),
                'metadata-view-top-nav': metadataView,
                'standard-panel-top-nav': !metadataView && !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
              }">
            <template v-if="!metadataView">
                <div class="metadata-top-row">
                    <div class="metadata-breadcrumb-wrap">
                        <nav aria-label="breadcrumb" style="display: flex;">
                            <ol class="breadcrumb comm-settings-top-nav m-0" style="justify-content: flex-start">
                                <li v-if="!excludeRoot.includes(usedBy)" class="breadcrumb-item" @click="changeComponent">
                                    <a>{{usedBy}}</a>
                                </li>

                                <template v-for="(folder,index) in folders">
                                    <template v-if="checkvisibility(folder) && folder.file_name != undefined && folder.file_name.length > 0">
                                        <li
                                            :key="folder._id"
                                            @click="index == folders.length-1 ? reloadButtonClicked() : changeDirectoryFromUrl(folder)"
                                            class="breadcrumb-item active-text-nav-bar"
                                            aria-current="page"
                                        >
                                            <a v-if="excludeRoot.includes(usedBy) && index == 0">{{usedBy}}</a>
                                            <span v-else style="word-break: break-all;">{{getDecodedFolderFolderName(folder.file_name)}} </span>
                                        </li>
                                    </template>
                                </template>

                                <div
                                    v-if="
                                    getProjectWorkspaceState() &&
                                    isFolderAvailable &&
                                    ['CatalogWorkspace','BinWorkspace'].includes(compoentType) &&
                                    (metadataView || (!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible))
                                    "
                                    class="breadcrumb-item"
                                    style="z-index: 11;">
                                    <svg xmlns="http://www.w3.org/2000/svg" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="bi bi-three-dots-vertical dropdown-toggle">
                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                                    </svg>
                                    <div class="dropdown-menu dropdown-menu-md-right p-0">
                                        <div @click="addBookmark = true" class="dropdown-item p-2">
                                            <div>{{$t('Add to Bookmark')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </ol>
                        </nav>
                    </div>

                    <div v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible" class="config-value">
                        <div
                            v-if="getProjectWorkspaceState() && compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)"
                            v-on:click="jobsPanelToggleFunction()"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" :fill="toggleJobsPanel?'#007bff':'#707070'" class="bi bi-card-list reload-button" style="margin-inline-end: 8px;" viewBox="0 0 16 16">
                                <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                                <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
                                <title>{{$t('Jobs')}}</title>
                            </svg>
                        </div>

                        <div v-if="compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)" class="mr-1">
                            <svg v-on:click="reloadButtonClicked()" xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#6c6c6c" class="bi bi-arrow-clockwise reload-button" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                <title>{{$t(compoentType)}}</title>
                            </svg>
                        </div>

                        <div style="display: flex;" class="w-100">
                            <div style="display: flex;align-items: center;" v-if="enableMoreActions && compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)">
                                <div v-if="fileStateFilter && fileStateFilter.state && fileStateFilter.state.includes('MARK FOR DELETE')" class="more-action-filters-tag mr-2">
                                    <div style="align-items: end;display: flex;">{{$t('Marked for delete')}}</div>
                                    <div><cancel-Icon @click.native="unselectMarkedForDeleteFilter()"></cancel-Icon></div>
                                </div>
                                <div v-if="fileStateFilter && fileStateFilter.state && fileStateFilter.state.includes('ERROR')" class="more-action-filters-tag mr-2">
                                    <div style="align-items: end;display: flex;">{{$t('Error')}}</div>
                                    <div><cancel-Icon @click.native="unselelectErrorFilter()"></cancel-Icon></div>
                                </div>
                                <div v-if="fileStateFilter && fileStateFilter.storage_class && fileStateFilter.storage_class.includes('Disk')" class="more-action-filters-tag mr-2">
                                    <div style="align-items: end;display: flex;">{{$t('Archived')}}</div>
                                    <div><cancel-Icon @click.native="unselelectArchivedFileStateFilter()"></cancel-Icon></div>
                                </div>
                                <div v-if="fileStateFilter && fileStateFilter.filter && fileStateFilter.filter.length > 0" class="more-action-filters-tag">
                                    <div style="align-items: end;display: flex;">{{$t('Non archived')}}</div>
                                    <div><cancel-Icon @click.native="unselelectNonArchivedFileStateFilter()"></cancel-Icon></div>
                                </div>
                            </div>

                            <div class="d-inline-flex edit-icon-visibility ml-2" id="sortBy_multiselect">
                                <Multiselect
                                    :options="sortByOptions"
                                    v-model="sortedVmodel"
                                    :searchable="false"
                                    :close-on-select="true"
                                    :allow-empty="false"
                                    label="label"
                                    :showNoOptions="false"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    :placeholder="$t('Sort By')"
                                    @select="sortByFilterChanged($event)"
                                    track-by="label">
                                    <template slot="singleLabel" slot-scope="scope">
                                        {{ $t(scope.option.label) }}
                                    </template>
                                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                        <span style="margin-inline-start:12px;">{{ $t(scope.option.label) }}</span>
                                    </div>
                                    <span slot="noResult">{{ $t('No results') }}.</span>
                                </Multiselect>
                            </div>

                            <div class="nav-item dropdown show more-actions-icon" v-if="enableMoreActions && compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)">
                                <a class="nav-item nav-link dropdown-toggle" id="bd-versions" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="true" style="padding:5px">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0z"/>
                                    </svg>
                                </a>
                                <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions" :style="workspace && workspace == 'Projects'?'inset-inline-start :-160px':''">
                                    <a class="dropdown-item p-2 d-flex" v-on:click="selectMarkedForDeleteFilter()">
                                        <span>{{$t('Show marked for delete files')}}</span>
                                    </a>
                                    <a class="dropdown-item p-2 d-flex" v-on:click="selectErrorFilter()">
                                        <span>{{$t('Show error files')}}</span>
                                    </a>
                                    <a class="dropdown-item p-2 d-flex" v-on:click="selectArchivedFilesDisplayFilter()">
                                        <span>{{$t('Show only archived files')}}</span>
                                    </a>
                                    <a class="dropdown-item p-2 d-flex" v-on:click="selectNonArchivedFilesDisplayFilter()">
                                        <span>{{$t('Show only non archived files')}}</span>
                                    </a>
                                    <a v-if="isCatalogsWorkspace" class="dropdown-item p-2 d-flex" v-on:click="openManageTableColumns()">
                                        <span>{{$t('Manage table columns')}}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- COMPACT UI: WHEN METADATA DOCK OR DETAILS PANEL IS OPEN -->
                    <div v-else class="metadata-toolbar-wrap normal-panel-toolbar">
                        <div v-if="compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)" class="metadata-icon-wrap">
                            <svg v-on:click="reloadButtonClicked()" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#6c6c6c" class="bi bi-arrow-clockwise reload-button" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                <title>{{$t(compoentType)}}</title>
                            </svg>
                        </div>

                        <div class="nav-item dropdown show more-actions-icon metadata-more-actions"
                            v-if="enableMoreActions && compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)">
                            <a class="nav-item nav-link dropdown-toggle" id="normal-panel-more-actions" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="true" style="padding:0 4px">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                </svg>
                            </a>

                            <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="normal-panel-more-actions" :style="workspace && workspace == 'Projects' ? 'inset-inline-start :-160px' : ''">
                                <a
                                    v-if="getProjectWorkspaceState() && compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)"
                                    class="dropdown-item p-2 d-flex"
                                    @click="jobsPanelToggleFunction()">
                                    <span>{{ toggleJobsPanel ? $t('Hide Jobs') : $t('Show Jobs') }}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" @click="addBookmark = true">
                                    <span>{{$t('Add to Bookmark')}}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" @click="toggleMetadataSortFilter()">
                                    <span>{{ showMetadataSortFilter ? $t('Hide sort by filter') : $t('Show sort by filter') }}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" v-on:click="selectMarkedForDeleteFilter()">
                                    <span>{{$t('Show marked for delete files')}}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" v-on:click="selectErrorFilter()">
                                    <span>{{$t('Show error files')}}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" v-on:click="selectArchivedFilesDisplayFilter()">
                                    <span>{{$t('Show only archived files')}}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" v-on:click="selectNonArchivedFilesDisplayFilter()">
                                    <span>{{$t('Show only non archived files')}}</span>
                                </a>
                                <a v-if="isCatalogsWorkspace" class="dropdown-item p-2 d-flex" v-on:click="openManageTableColumns()">
                                    <span>{{$t('Manage table columns')}}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                v-if="getIsMetadataDockVisible || getIsAssetsDetailsPanelVisible"
                class="metadata-second-row normal-panel-filter-row"
              >
                <div
                  v-if="showMetadataSortFilter"
                  id="sortBy_multiselect"
                  class="metadata-sort-row-wrap normal-panel-sort-wrap"
                >
                  <Multiselect
                    :options="sortByOptions"
                    v-model="sortedVmodel"
                    :searchable="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    label="label"
                    :showNoOptions="false"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    :placeholder="$t('Sort By')"
                    @select="sortByFilterChanged($event)"
                    track-by="label"
                  >
                    <template slot="singleLabel" slot-scope="scope">
                      {{ $t(scope.option.label) }}
                    </template>
              
                    <div
                      style="display:flex;max-height:12px;align-items:center;"
                      class="checkbox-label"
                      slot="option"
                      slot-scope="scope"
                    >
                      <span style="margin-inline-start:12px;">{{ $t(scope.option.label) }}</span>
                    </div>
              
                    <span slot="noResult">{{ $t('No results') }}.</span>
                  </Multiselect>
                </div>
              
                <div
                  class="metadata-filter-row normal-panel-applied-filter-row"
                  v-if="enableMoreActions && compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)"
                >
                  <div
                    v-if="fileStateFilter && fileStateFilter.state && fileStateFilter.state.includes('MARK FOR DELETE')"
                    class="more-action-filters-tag"
                  >
                    <div style="align-items: end;display: flex;">{{$t('Marked for delete')}}</div>
                    <div><cancel-Icon @click.native="unselectMarkedForDeleteFilter()"></cancel-Icon></div>
                  </div>
              
                  <div
                    v-if="fileStateFilter && fileStateFilter.state && fileStateFilter.state.includes('ERROR')"
                    class="more-action-filters-tag"
                  >
                    <div style="align-items: end;display: flex;">{{$t('Error')}}</div>
                    <div><cancel-Icon @click.native="unselelectErrorFilter()"></cancel-Icon></div>
                  </div>
              
                  <div
                    v-if="fileStateFilter && fileStateFilter.storage_class && fileStateFilter.storage_class.includes('Disk')"
                    class="more-action-filters-tag"
                  >
                    <div style="align-items: end;display: flex;">{{$t('Archived')}}</div>
                    <div><cancel-Icon @click.native="unselelectArchivedFileStateFilter()"></cancel-Icon></div>
                  </div>
              
                  <div
                    v-if="fileStateFilter && fileStateFilter.filter && fileStateFilter.filter.length > 0"
                    class="more-action-filters-tag"
                  >
                    <div style="align-items: end;display: flex;">{{$t('Non archived')}}</div>
                    <div><cancel-Icon @click.native="unselelectNonArchivedFileStateFilter()"></cancel-Icon></div>
                  </div>
                </div>
              </div>
            </template>

            <template v-else>
                <div class="metadata-top-row">
                    <div class="metadata-breadcrumb-wrap">
                        <nav aria-label="breadcrumb" style="display: flex;">
                            <ol class="breadcrumb comm-settings-top-nav m-0" :style="metadataView?'padding:0px !important':''" style="justify-content: flex-start">
                                <li v-if="!excludeRoot.includes(usedBy)" class="breadcrumb-item" @click="changeComponent"><a>{{usedBy}}</a></li>
                                <template v-if="metadataView">
                                    <template v-for="(folder, index) in folders">
                                        <li v-if="folders.length <= 3 || index === 0 || index === folders.length - 1"
                                            :key="folder._id"
                                            @click="index === folders.length - 1 ? reloadButtonClicked() : changeDirectoryFromUrl(folder)"
                                            class="breadcrumb-item active-text-nav-bar">
                                            <span>{{ getDecodedFolderFolderName(folder.file_name) }}</span>
                                        </li>

                                        <li v-else-if="index === 1"
                                            :key="folder._id"
                                            class="breadcrumb-item dropdown" style="display: flex;align-items: baseline;">
                                            <a class="dropdown-toggle" data-toggle="dropdown" style="text-decoration: none;font-size:14px">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-md-right p-0">
                                                <template v-for="(midFolder, midIndex) in folders">
                                                    <a v-if="midIndex > 0 && midIndex < folders.length - 1"
                                                       :key="midFolder._id"
                                                       class="dropdown-item"
                                                       @click="changeDirectoryFromUrl(midFolder)">
                                                        {{ getDecodedFolderFolderName(midFolder.file_name) }}
                                                    </a>
                                                </template>
                                            </div>
                                        </li>
                                    </template>
                                </template>
                            </ol>
                        </nav>
                    </div>

                    <div class="metadata-toolbar-wrap">
                        <div v-if="compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)" class="metadata-icon-wrap">
                            <svg v-on:click="reloadButtonClicked()" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#6c6c6c" class="bi bi-arrow-clockwise reload-button" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                <title>{{$t(compoentType)}}</title>
                            </svg>
                        </div>

                        <div class="nav-item dropdown show more-actions-icon metadata-more-actions"
                            v-if="enableMoreActions && compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)">
                            <a class="nav-item nav-link dropdown-toggle" id="metadata-more-actions" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="true" style="padding:0 4px">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                </svg>
                            </a>

                            <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="metadata-more-actions" :style="workspace && workspace == 'Projects' ? 'inset-inline-start :-160px' : ''">
                                <a
                                    v-if="getProjectWorkspaceState() && compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)"
                                    class="dropdown-item p-2 d-flex"
                                    @click="jobsPanelToggleFunction()">
                                    <span>{{ toggleJobsPanel ? $t('Hide Jobs') : $t('Show Jobs') }}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" @click="addBookmark = true">
                                    <span>{{$t('Add to Bookmark')}}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" @click="toggleMetadataSortFilter()">
                                    <span>{{ showMetadataSortFilter ? $t('Hide sort by filter') : $t('Show sort by filter') }}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" v-on:click="selectMarkedForDeleteFilter()">
                                    <span>{{$t('Show marked for delete files')}}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" v-on:click="selectErrorFilter()">
                                    <span>{{$t('Show error files')}}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" v-on:click="selectArchivedFilesDisplayFilter()">
                                    <span>{{$t('Show only archived files')}}</span>
                                </a>
                                <a class="dropdown-item p-2 d-flex" v-on:click="selectNonArchivedFilesDisplayFilter()">
                                    <span>{{$t('Show only non archived files')}}</span>
                                </a>
                                <a v-if="isCatalogsWorkspace" class="dropdown-item p-2 d-flex" v-on:click="openManageTableColumns()">
                                    <span>{{$t('Manage table columns')}}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="metadataView"
                    class="metadata-second-row"
                >
                    <div v-if="showMetadataSortFilter" id="sortBy_multiselect" class="metadata-sort-row-wrap">
                        <Multiselect
                            :options="sortByOptions"
                            v-model="sortedVmodel"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="false"
                            label="label"
                            :showNoOptions="false"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            placeholder="Sort By"
                            @select="sortByFilterChanged($event)"
                            track-by="label">
                            <template slot="singleLabel" slot-scope="scope">
                                {{ $t(scope.option.label) }}
                            </template>
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <span style="margin-inline-start:12px;">{{ $t(scope.option.label) }}</span>
                            </div>
                            <span slot="noResult">{{ $t('No results') }}.</span>
                        </Multiselect>
                    </div>

                    <div class="metadata-filter-row" v-if="enableMoreActions && compoentType && !['FileBrowserWorkspace','BinsRootWorkspace'].includes(compoentType)">
                        <div v-if="fileStateFilter && fileStateFilter.state && fileStateFilter.state.includes('MARK FOR DELETE')" class="more-action-filters-tag mr-2 mb-1">
                            <div style="align-items: end;display: flex;">{{$t('Marked for delete')}}</div>
                            <div><cancel-Icon @click.native="unselectMarkedForDeleteFilter()"></cancel-Icon></div>
                        </div>
                        <div v-if="fileStateFilter && fileStateFilter.state && fileStateFilter.state.includes('ERROR')" class="more-action-filters-tag mr-2 mb-1">
                            <div style="align-items: end;display: flex;">{{$t('Error')}}</div>
                            <div><cancel-Icon @click.native="unselelectErrorFilter()"></cancel-Icon></div>
                        </div>
                        <div v-if="fileStateFilter && fileStateFilter.storage_class && fileStateFilter.storage_class.includes('Disk')" class="more-action-filters-tag mr-2 mb-1">
                            <div style="align-items: end;display: flex;">{{$t('Archived')}}</div>
                            <div><cancel-Icon @click.native="unselelectArchivedFileStateFilter()"></cancel-Icon></div>
                        </div>
                        <div v-if="fileStateFilter && fileStateFilter.filter && fileStateFilter.filter.length > 0" class="more-action-filters-tag mb-1">
                            <div style="align-items: end;display: flex;">{{$t('Non archived')}}</div>
                            <div><cancel-Icon @click.native="unselelectNonArchivedFileStateFilter()"></cancel-Icon></div>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <add-fav v-if="enableAddFav" v-bind="currentProperties" @close="enableAddFav=false"></add-fav>
        <addBookmark v-if="addBookmark" v-bind="currentProperties" @close="addBookmark=false"></addBookmark>
        <configurableTableColumns v-if="showManageTableColumnsModal" :show="showManageTableColumnsModal" @columns-updated="handleColumnsUpdated" @close="showManageTableColumnsModal = false"></configurableTableColumns>
    </div>
</template>

<script>
import Utils from '../../components.utils';
import Multiselect from 'vue-multiselect';
import cancelIcon from "../core/InlineCancelField.vue";
import AddFavEntry from "../../components/Favorites/AddOrEditFavorite.vue"
import addBookmark from "../../components/Favorites/AddOrEditBookMark.vue"
import configurableTableColumns from "../../components/categories/ConfigurableTableColumns.vue"
import { mapGetters } from 'vuex'

export default {
    data(){
        return{
            excludeRoot : ['Catalogs'],
            sortByOptions:[
                {label:'Relevance',sortOn:'added_datetime',ascDesc:-1},
                {label:'Latest',sortOn:'created_datetime',ascDesc:-1},
                {label:'Oldest',sortOn:'created_datetime',ascDesc:1},
                {label:'Name - A to Z',sortOn:'file_name',ascDesc:1},
                {label:'Name - Z to A',sortOn:'file_name',ascDesc:-1},
                {label:'Size - Largest first',sortOn:'size',ascDesc:-1},
                {label:'Size - Smallest first',sortOn:'size',ascDesc:1},
                {label:'Duration - Largest first',sortOn:'duration',ascDesc:-1},
                {label:'Duration - Smallest first',sortOn:'duration',ascDesc:1},
            ],
            sortedVmodel:{},
            mfdState:false,
            fileStateFilter:{ storage_class: [], state: [], filter: '' },
            enableMenu:false,
            enableAddFav:false,
            addBookmark:false,
            enableMoreActions:true,
            toggleJobsPanel:Utils.getCookieValue('jobPanelState'),
            showMiddleMenu: false,
            showMetadataSortFilter: false,
            showManageTableColumnsModal: false
        }
    },

    props:[
        "usedBy",
        "dirs",
        "sortedOption",
        "compoentType",
        "folderBrowseEnabled",
        "getCookieValueOfJobPanel",
        "workspace",
        "rootCatalogInfo",
        "metadataView"
    ],

    computed: {
        isCatalogsWorkspace(){
            return this.compoentType === "CatalogWorkspace";
        },
        folders(){
            if(this.workspace && this.workspace == "Projects"){
                Utils.saveFolderHistory(this.dirs)
            }
            return this.dirs
        },

        isFolderAvailable(){
            let isValidWorkspace = true;
            if(this.dirs.length == 1){
                let op = this.dirs[0]
                if(op && "_id" in op && op._id == 0){
                    isValidWorkspace = false;
                }
            }
            return isValidWorkspace;
        },

        currentProperties() {
            let folderName = ""
            let currentDir = this.dirs[this.dirs.length - 1]
            if(currentDir){
                folderName = currentDir.file_name
            }
            return { favInfo : { name:folderName, type:"bookmark" }, newFav:"true" }
        },

        ...mapGetters("users", [
            "getIsMetadataDockVisible",
            "getIsAssetsDetailsPanelVisible",
            "getLoggedInUserAccessControl",
            "getLoggedInUserPrivilege"
        ]),
    },

    methods:{
        isFileBrowserWorkspace(){
            return ![undefined, null].includes(this.compoentType) &&
                this.compoentType == "FileBrowserWorkspace";
        },

        getDefaultFileStateFilter(){
            return {
                storage_class: [],
                state: [],
                filter: ''
            };
        },

        normalizeFileStateFilter(filter){
            if(!filter){
                return this.getDefaultFileStateFilter();
            }

            return {
                storage_class: Array.isArray(filter.storage_class) ? filter.storage_class : [],
                state: Array.isArray(filter.state) ? filter.state : [],
                filter: filter.filter || ''
            };
        },

        safeParseFromLocalStorage(key, fallback){
            try {
                const value = localStorage.getItem(key);
                if([undefined, null, ''].includes(value)){
                    return fallback;
                }
                return JSON.parse(value);
            } catch (e) {
                return fallback;
            }
        },

        getFileStateFilterStorageKey(){
            return this.isFileBrowserWorkspace()
                ? 'file-browse-file-status-filter-state'
                : 'file-status-filter-state';
        },

        getSortByFilterStorageKey(){
            return this.isFileBrowserWorkspace()
                ? 'file-browse-sort-by-filter-state'
                : 'file-sort-by-filter-state';
        },

        getMetadataSortFilterVisibilityStorageKey(){
            return this.isFileBrowserWorkspace()
                ? 'file-browse-metadata-sort-filter-visible'
                : 'metadata-sort-filter-visible';
        },

        getSavedFileStateFilter(){
            const savedFilter = this.safeParseFromLocalStorage(
                this.getFileStateFilterStorageKey(),
                null
            );

            return this.normalizeFileStateFilter(savedFilter);
        },

        saveFileStateFilter(){
            localStorage.setItem(
                this.getFileStateFilterStorageKey(),
                JSON.stringify(this.normalizeFileStateFilter(this.fileStateFilter))
            );
        },

        getSavedSortByOption(){
            const savedSort = this.safeParseFromLocalStorage(
                this.getSortByFilterStorageKey(),
                null
            );

            if(!savedSort || !savedSort.label){
                return null;
            }

            const matchingOption = this.sortByOptions.find(option => option.label == savedSort.label);
            return matchingOption || savedSort;
        },

        saveSortByOption(option){
            if(!option || !option.label){
                return;
            }

            localStorage.setItem(
                this.getSortByFilterStorageKey(),
                JSON.stringify(option)
            );
        },

        getSavedMetadataSortFilterVisibility(){
            return this.safeParseFromLocalStorage(
                this.getMetadataSortFilterVisibilityStorageKey(),
                null
            );
        },

        saveMetadataSortFilterVisibility(value){
            localStorage.setItem(
                this.getMetadataSortFilterVisibilityStorageKey(),
                JSON.stringify(!!value)
            );
        },

        hasActiveFileStateFilter(filter){
            const normalizedFilter = this.normalizeFileStateFilter(filter);

            return (
                normalizedFilter.state.length > 0 ||
                normalizedFilter.storage_class.length > 0 ||
                normalizedFilter.filter.length > 0
            );
        },

        shouldUseMetadataFilterArea(){
            return this.metadataView ||
                (!this.metadataView && (this.getIsMetadataDockVisible || this.getIsAssetsDetailsPanelVisible));
        },

        restorePersistedFilterState(emitToParent = false){
            const savedSort = this.getSavedSortByOption();

            if(savedSort){
                this.sortedVmodel = savedSort;
            }else{
                this.sortedVmodel = this.sortedOption || {};
            }

            this.fileStateFilter = this.getSavedFileStateFilter();

            const savedVisibility = this.getSavedMetadataSortFilterVisibility();

            if(savedVisibility !== null){
                this.showMetadataSortFilter = savedVisibility;
            }else{
                this.showMetadataSortFilter = this.shouldUseMetadataFilterArea() && !!savedSort;
            }

            if(emitToParent){
                this.$nextTick(() => {
                    if(
                        this.compoentType !== 'BinWorkspace' &&
                        savedSort
                    ){
                        this.$emit('sort-by-filter-updated', savedSort);
                    }
                    if(
                        this.compoentType !== 'BinWorkspace' &&
                        this.hasActiveFileStateFilter(this.fileStateFilter)
                    ){
                        this.$emit('fileStateFilterUpdated', this.fileStateFilter);
                    }
                });
            }
        },

        syncMetadataSortFilterVisibility(){
            const savedVisibility = this.getSavedMetadataSortFilterVisibility();
            const savedSort = this.getSavedSortByOption();

            if(savedVisibility !== null){
                this.showMetadataSortFilter = savedVisibility;
            }else if(this.shouldUseMetadataFilterArea() && savedSort){
                this.showMetadataSortFilter = true;
            }
        },

        ensureFileStateFilterObject(){
            this.fileStateFilter = this.normalizeFileStateFilter(this.fileStateFilter);
        },

        handleColumnsUpdated(columnIds) {
            this.$emit('columns-updated', columnIds)
        },

        openManageTableColumns(){
           this.showManageTableColumnsModal = true;
        },

        toggleMetadataSortFilter(){
            this.showMetadataSortFilter = !this.showMetadataSortFilter;
            this.saveMetadataSortFilterVisibility(this.showMetadataSortFilter);
        },

        checkvisibility(folderInfo){
            if(!this.getProjectWorkspaceState() && !this.excludeRoot[0] && (folderInfo.file_name == this.usedBy)){
                return false;
            }else{
                return true;
            }
        },

        getProjectWorkspaceState(){
            if(this.workspace && this.workspace == 'Projects'){
                return false;
            }
            return true;
        },

        getDecodedFolderFolderName(fileName){
            if(typeof fileName == "undefined"){
                return ""
            }
            return decodeURIComponent(fileName)
        },

        changeComponent(){
            let comp = null
            if (this.usedBy == "Bins"){
                comp = "bins-display";
                Utils.updateCookieByKeyName("context","bins-display")
            }else{
                if(this.workspace == 'Projects'){
                    comp = "assets-projects";
                }else{
                    comp = "catalogs-display"
                    Utils.updateCookieByKeyName("context","catalogs-display")
                }
            }
            this.$emit("changeComponent", comp)
        },

        reloadButtonClicked(){
            this.$emit("reloadThePage")
            this.$toast.info("Reloaded !")
        },

        changeDirectoryFromUrl(folderName){
            this.$emit("changeDirectoryFromUrl", folderName);
        },

        selectMarkedForDeleteFilter(){
            this.ensureFileStateFilterObject();

            if(this.fileStateFilter.state.includes("MARK FOR DELETE")){
                return false;
            }

            this.fileStateFilter.state.push("MARK FOR DELETE");
            this.emitFilterStateToParent();
        },

        unselectMarkedForDeleteFilter(){
            this.ensureFileStateFilterObject();
            this.fileStateFilter.state = this.fileStateFilter.state.filter(e => e != 'MARK FOR DELETE');
            this.emitFilterStateToParent();
        },

        selectErrorFilter(){
            this.ensureFileStateFilterObject();

            if(this.fileStateFilter.state.includes("ERROR")){
                return false;
            }

            this.fileStateFilter.state.push("ERROR");
            this.emitFilterStateToParent();
        },

        unselelectErrorFilter(){
            this.ensureFileStateFilterObject();
            this.fileStateFilter.state = this.fileStateFilter.state.filter(e => e != 'ERROR');
            this.emitFilterStateToParent();
        },

        selectArchivedFilesDisplayFilter(){
            this.ensureFileStateFilterObject();

            if(this.fileStateFilter.storage_class.includes("Disk")){
                return false;
            }

            this.fileStateFilter.storage_class.push("Disk");

            if(this.fileStateFilter.filter == 'non_archived'){
                this.fileStateFilter.filter = '';
            }

            this.emitFilterStateToParent();
        },

        unselelectArchivedFileStateFilter(){
            this.ensureFileStateFilterObject();
            this.fileStateFilter.storage_class = this.fileStateFilter.storage_class.filter(e => e != 'Disk');
            this.emitFilterStateToParent();
        },

        selectNonArchivedFilesDisplayFilter(){
            this.ensureFileStateFilterObject();

            if(this.fileStateFilter.filter && this.fileStateFilter.filter.length > 0){
                return false;
            }

            this.fileStateFilter.filter = 'non_archived';

            if(this.fileStateFilter.storage_class.includes('Disk')){
                this.fileStateFilter.storage_class = this.fileStateFilter.storage_class.filter(e => e != 'Disk');
            }

            this.emitFilterStateToParent();
        },

        unselelectNonArchivedFileStateFilter(){
            this.ensureFileStateFilterObject();
            this.fileStateFilter.filter = '';
            this.emitFilterStateToParent();
        },

        emitFilterStateToParent(){
            this.ensureFileStateFilterObject();
            this.saveFileStateFilter();
            this.$emit('fileStateFilterUpdated', this.fileStateFilter);
        },

        sortByFilterChanged(option){
            if(!option){
                return;
            }

            this.sortedVmodel = option;
            this.saveSortByOption(option);

            if(this.shouldUseMetadataFilterArea()){
                this.showMetadataSortFilter = true;
                this.saveMetadataSortFilterVisibility(true);
            }

            this.$emit('sort-by-filter-updated', option);
        },

        jobsPanelToggleFunction(){
            this.toggleJobsPanel = !this.toggleJobsPanel;
            this.$emit("changeJobsPanelState", this.toggleJobsPanel)
        }
    },

    components:{
        "cancel-Icon":cancelIcon,
        Multiselect,
        "add-fav": AddFavEntry,
        addBookmark,
        configurableTableColumns
    },

    created(){
        if(this.workspace && this.workspace == 'Projects'){
            this.excludeRoot = [this.rootCatalogInfo.catalog_name]
        }else{
            this.excludeRoot = ["Catalogs"]
        }

        if(this.folderBrowseEnabled){
            this.enableMoreActions = false
        }

        this.restorePersistedFilterState(true);
    },

    watch:{
        rootCatalogInfo(newVal, oldVal){
            if(newVal != oldVal){
                this.excludeRoot = [newVal.catalog_name]
            }
        },

        getCookieValueOfJobPanel(newVal){
            if(!newVal){
                this.toggleJobsPanel = false;
            }
        },

        metadataView(){
            this.syncMetadataSortFilterVisibility();
        },

        getIsMetadataDockVisible(){
            this.syncMetadataSortFilterVisibility();
        },

        getIsAssetsDetailsPanelVisible(){
            this.syncMetadataSortFilterVisibility();
        },

        sortedOption: {
            deep: true,
            handler(newVal){
                const savedSort = this.getSavedSortByOption();

                if(savedSort){
                    this.sortedVmodel = savedSort;
                    return;
                }

                if(newVal && newVal.label){
                    this.sortedVmodel = newVal;
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $applied-filter-background: #1c6c8e;
  $secondary-border-color:#767676;

.breadcrumb{
  padding: .75rem 1rem !important;
    .active-text-nav-bar{
        color: $text-color !important;
    }
    .active-text-nav-bar:hover{
        text-decoration: underline;
    }
    .breadcrumb-item{
        a{
            font-size: 24px;
            color: $text-color;
        }
        a:hover{
            text-decoration: underline;
        }
    }

    .breadcrumb-item+.breadcrumb-item::before {
        padding-inline-end : .5rem !important;
        float:inline-start !important;
    }
}

.breadcrumb-dropdown{
    background-color: #181b26 !important;
    border: 1px solid #21252f;
    .dropdown-item{
        padding:7px 10px;
    }
}

.comm-settings-top-nav{
    background: transparent !important;
    display: flex;
    align-items: baseline;
    color: $secondary-text-color !important;
    justify-content: space-between;
}

.metadata-top-nav{
    display: flex !important;
    flex-direction: column;
    align-items: stretch !important;
    justify-content: flex-start !important;
    gap: 8px;
}

.metadata-top-row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    min-width: 0;
}

.metadata-breadcrumb-wrap{
    flex: 1;
    min-width: 0;
}

.metadata-breadcrumb-wrap .breadcrumb{
    margin-bottom: 0;
    min-width: 0;
    flex-wrap: nowrap;
}

.metadata-breadcrumb-wrap .breadcrumb-item{
    white-space: nowrap;
}

.metadata-toolbar-wrap{
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}

.normal-panel-toolbar {
    margin-inline-start: auto;
    justify-content: flex-end;
}

.metadata-second-row{
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding-inline-start: 1rem;
}

.metadata-filter-row{
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    width: 100%;
}

.metadata-icon-wrap{
    display: flex;
    align-items: center;
}

.metadata-more-actions{
    display: flex;
    align-items: center;
}

.metadata-breadcrumb{
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow: hidden;
    min-width: 0;
}

.metadata-breadcrumb .breadcrumb-item{
    white-space: nowrap;
    flex-shrink: 0;
}

.metadata-breadcrumb .breadcrumb-item span,
.metadata-breadcrumb .breadcrumb-item a{
    overflow: hidden;
    text-overflow: ellipsis;
}

.metadata-middle-dropdown{
    display: flex;
    align-items: baseline;
}

.metadata-sort-wrap{
    min-width: 110px;
    width: 110px;
}

::v-deep {
    // .metadata-sort-row-wrap{
    //     width: 160px;
    //     .multiselect__select{
    //         inset-inline-end:10px !important;
    //     }
    // }
    .metadata-sort-row-wrap {
        width: fit-content !important;
        min-width: 110px;
        max-width: 280px;
        flex: 0 0 auto !important;
    }
    .commDefaultdropDownFields{
        width:auto;
        display: inline-block;
        .multiselect__tags, .multiselect__select{
            border: none !important;
            background: transparent !important;
            background-color: transparent !important;
        }
        .multiselect__tags{
            padding-inline-end:10px;
        }
        .multiselect__select{
            display: none;
        }
        .multiselect__content-wrapper{
            display: none;
        }
    }

    .multiselect{
        color:$text-color !important;
        font-size: 12px !important;
        height: $input-field-height;
        min-height: $input-field-height;
        margin-inline-end: 20px;
        position: relative;
        top: 5px !important;
    }

    #sortBy_multiselect .multiselect{
       width: fit-content !important;
        min-width: 110px;
        max-width: 280px;
        margin: 0 !important;
        position: relative;
    }
    #sortBy_multiselect:hover{
        .multiselect__tags{
            border: 1px solid $secondary-border-color !important;
        }
    }

    // #sortBy_multiselect .multiselect__content-wrapper{
    //     width: 185px !important;
    // }

    #sortBy_multiselect .multiselect__tags {
        width: auto !important;
        min-width: 110px;
        max-width: 280px;

        /*
         * Keep enough space for dropdown arrow.
         * This prevents selected text from going under the arrow.
         */
        padding-inline-start: 8px !important;
        padding-inline-end: 38px !important;

        white-space: nowrap;
    }

    #sortBy_multiselect .multiselect__single {
        width: auto !important;
        white-space: nowrap;
        overflow: visible;
        padding: 0 !important;
        margin: 0 !important;
    }

    
    #sortBy_multiselect .multiselect__select {
        position: absolute !important;
        inset-inline-end: 0 !important;
        top: 0 !important;

        width: 38px !important;
        height: 100% !important;

        padding: 0 !important;
        line-height: normal !important;

        transform: none !important;
    }

    #sortBy_multiselect .multiselect__select::before {
        top: 50% !important;
        margin-top: -3px !important;
        transform: none !important;
    }

    #sortBy_multiselect .multiselect--active .multiselect__select {
        transform: none !important;
    }

    #sortBy_multiselect .multiselect--active .multiselect__select::before {
        top: 50% !important;
        margin-top: -3px !important;
        transform: none !important;
    }

    #sortBy_multiselect .multiselect__content-wrapper {
        width: max-content !important;
        min-width: 100% !important;
        max-width: 300px;
    }

    #sortBy_multiselect .multiselect__content {
        min-width: 100%;
        width: max-content;
    }

    #sortBy_multiselect .multiselect__option {
        white-space: nowrap;
    }

    .multiselect__tag {
        background-color: $primary-background;
    }
    .multiselect__tags{
        background: $primary-background;
        border: $border-color;
        padding: 0px 40px 0 0px !important;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
        align-items: center;
        margin:0px !important;
        height: 100%;
        padding-inline-start: 5px;
        padding: 0 0 0 5px;
    }
    .multiselect__single {
      margin: 0px !important;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
    .multiselect__tag-icon{
        color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
        color:$text-color !important;
        font-size: $input-field-and-label-font-size !important;
        height: $input-field-height;
        min-height: $input-field-height;
        margin-inline-end: 2px;
        position: relative;
        top: 8px;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: $border-color !important;
        position: relative;
        display: block;
        background: $secondary-background-color !important;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }

    .multiselect__select{line-height: 2px !important;}
    .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: transparent;
        padding-inline-start: 0px !important;
        height: 30px !important;
        width: 146px;
        min-height: 23px;
        display: flex;
        align-items: center;
        margin:0px !important;
        height: 100%;
        padding-inline-start: 8px !important;
    }

    .multiselect__placeholder{
      display: flex;
      align-items: center;
      margin:0px !important;
      height: 100%;
      padding-inline-start: 5px;
    }
}

.more-actions-icon{
    display: flex;
    align-items: center;
}

.more-action-filters-tag{
    width: max-content;
    display: flex;
    border: 1px solid #3a3a3a;
    border-radius: 29px;
    padding: 3px;
    padding-inline-start: 11px;
    color: $text-color;
    background: $applied-filter-background !important;
}

.config-value{
    display: flex;
    position: relative;
    align-items: center;
}

.reload-button:hover{
    fill: $text-color;
}

.dropdown-toggle{
    color: $secondary-text-color;
}

.dropdown-toggle:hover{
    fill: $text-color;
    svg{
        fill: $text-color;
    }
}

.shortcut-actions-type-icons-wrapper{
    visibility: hidden;
    color: #999;
    background: #15181b!important;
    height: 30px;
    align-items: center;
    min-width: 130px;
    width: auto;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    position: absolute;
    line-height: 1;
    margin-inline-start: 8px;
    border: 1px solid #4a4a4a;
    --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
    box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
    display: flex;
    padding: 8px;
    border-radius: 0.375em;
    svg{
        margin-inline-start: 6px;
        margin-inline-end: 6px;
    }
}

.breadcrumb-item:hover{
    .shortcut-actions-type-icons-wrapper{
        visibility: visible;
    }
}

.shortcut-actions-type-icons-wrapper svg:hover{
    fill: #fdfff4;
}

.shortcut-actions-type-icons-wrapper:hover{
    color: #fdfff4 !important;
}

.shortcut-actions-type-icons-wrapper .copy-link-action{
    color: #a3adad !important;
}

.normal-panel-top-nav {
    gap: 4px !important;
  }
  
  .normal-panel-top-nav .metadata-top-row {
    display: flex !important;
    align-items: flex-start !important;
    justify-content: space-between !important;
    width: 100% !important;
    min-width: 0 !important;
    overflow: visible !important;
  }
  
  .normal-panel-top-nav .metadata-breadcrumb-wrap {
    flex: 1 1 auto !important;
    min-width: 0 !important;
    overflow: visible !important;
  }
  
  .normal-panel-top-nav .metadata-breadcrumb-wrap nav {
    width: 100% !important;
    overflow: visible !important;
  }
  
  .normal-panel-top-nav .metadata-breadcrumb-wrap .breadcrumb {
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    row-gap: 3px !important;
    column-gap: 0 !important;
    overflow: visible !important;
    white-space: normal !important;
    padding: 0.65rem 0.5rem 0.2rem 1rem !important;
  }
  
  .normal-panel-top-nav .metadata-breadcrumb-wrap .breadcrumb-item {
    display: inline-flex !important;
    align-items: center !important;
    flex: 0 0 auto !important;
    max-width: 100% !important;
    white-space: nowrap !important;
    overflow: visible !important;
  }
  
  .normal-panel-top-nav .metadata-breadcrumb-wrap .breadcrumb-item span,
  .normal-panel-top-nav .metadata-breadcrumb-wrap .breadcrumb-item a {
    display: inline-flex !important;
    max-width: 100% !important;
    white-space: nowrap !important;
    overflow: visible !important;
    text-overflow: unset !important;
    word-break: normal !important;
  }
  
  .normal-panel-top-nav .normal-panel-toolbar {
    flex: 0 0 auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    align-self: flex-start !important;
    margin-top: 12px !important;
    margin-inline-start: 6px !important;
    gap: 6px !important;
  }
  
  .normal-panel-top-nav .metadata-icon-wrap,
  .normal-panel-top-nav .metadata-more-actions {
    height: 24px !important;
    display: inline-flex !important;
    align-items: center !important;
  }
  
  .normal-panel-filter-row {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    gap: 8px !important;
    width: 100% !important;
    padding-inline-start: 1rem !important;
    padding-inline-end: 0.5rem !important;
    margin-top: 0 !important;
  }
  
  .normal-panel-sort-wrap {
    flex: 0 0 160px !important;
    width: 160px !important;
    min-width: 150px !important;
  }
  
  .normal-panel-applied-filter-row {
    flex: 1 1 auto !important;
    min-width: 0 !important;
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    gap: 6px !important;
    width: auto !important;
  }
  
  .normal-panel-applied-filter-row .more-action-filters-tag {
    margin: 0 !important;
    max-width: 100% !important;
    white-space: nowrap !important;
  }
  
  ::v-deep .normal-panel-sort-wrap .multiselect {
    top: 0 !important;
    height: 30px !important;
    min-height: 30px !important;
  }
  
  ::v-deep .normal-panel-sort-wrap .multiselect__tags {
    height: 30px !important;
    min-height: 30px !important;
  }

  .standard-panel-top-nav {
    width: 100% !important;
    min-width: 0 !important;
    overflow: visible !important;
  }
  
  .standard-panel-top-nav .metadata-top-row {
    display: flex !important;
    align-items: flex-start !important;
    justify-content: space-between !important;
    width: 100% !important;
    min-width: 0 !important;
    gap: 8px !important;
    overflow: visible !important;
  }
  
  .standard-panel-top-nav .metadata-breadcrumb-wrap {
    flex: 1 1 auto !important;
    min-width: 0 !important;
    max-width: 100% !important;
    overflow: visible !important;
  }
  
  .standard-panel-top-nav .metadata-breadcrumb-wrap nav {
    width: 100% !important;
    min-width: 0 !important;
    overflow: visible !important;
  }
  
  .standard-panel-top-nav .metadata-breadcrumb-wrap .breadcrumb {
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    row-gap: 3px !important;
    column-gap: 0 !important;
    width: 100% !important;
    min-width: 0 !important;
    overflow: visible !important;
    white-space: normal !important;
    padding: 0.65rem 0.5rem 0.2rem 1rem !important;
  }
  
  .standard-panel-top-nav .metadata-breadcrumb-wrap .breadcrumb-item {
    display: inline-flex !important;
    align-items: center !important;
    flex: 0 1 auto !important;
    min-width: 0 !important;
    max-width: 100% !important;
    white-space: normal !important;
    overflow: visible !important;
  }
  
  .standard-panel-top-nav .metadata-breadcrumb-wrap .breadcrumb-item span,
  .standard-panel-top-nav .metadata-breadcrumb-wrap .breadcrumb-item a {
    display: inline !important;
    max-width: 100% !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    word-break: break-word !important;
    overflow-wrap: anywhere !important;
  }
  
  .standard-panel-top-nav .config-value {
    flex: 0 0 auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    align-self: flex-start !important;
    margin-top: 8px !important;
    margin-inline-start: 8px !important;
    overflow: visible !important;
    position: relative !important;
    z-index: 2 !important;
  }
  
  /* Keep selected filters inside available right area */
  .standard-panel-top-nav .config-value > div[style*="display: flex"] {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    flex-wrap: wrap !important;
    gap: 6px !important;
    width: auto !important;
    min-width: 0 !important;
    overflow: visible !important;
  }
  
  .standard-panel-top-nav .more-action-filters-tag {
    margin: 0 6px 4px 0 !important;
    white-space: nowrap !important;
  }
  
//   .standard-panel-top-nav #sortBy_multiselect {
//     width: 150px !important;
//     min-width: 150px !important;
//     flex: 0 0 150px !important;
//   }
    .standard-panel-top-nav #sortBy_multiselect {
        width: fit-content !important;
        min-width: 110px;
        max-width: 280px;
        flex: 0 0 auto !important;
    }
  
//   .standard-panel-top-nav .edit-icon-visibility {
//     width: 150px !important;
//     min-width: 150px !important;
//     flex: 0 0 150px !important;
//   }
    .standard-panel-top-nav .edit-icon-visibility {
        width: fit-content !important;
        min-width: 110px !important;
        max-width: 280px !important;
        flex: 0 0 auto !important;
    }

  
  .standard-panel-top-nav .more-actions-icon {
    flex: 0 0 auto !important;
  }
</style>